
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

export enum ToggleSwitchSize {
  Small = 'small',
  Large = 'large',
}

@Component
export default class ToggleSwitch extends Vue {
  @Prop({ default: 'Check' }) textDescription!: string;
  @Prop({ default: true }) checkedValue!: boolean;
  @Prop({ default: ToggleSwitchSize.Large }) size!: ToggleSwitchSize;
  @Prop({ default: false }) disabled!: boolean;

  currentCheckedValue = this.checkedValue;

  @Watch('currentCheckedValue')
  @Emit('update:value')
  onUpdateInput(newValue: boolean): boolean {
    return newValue;
  }

  @Watch('checkedValue')
  onCheckedValueChanged(newValue: boolean): void {
    this.currentCheckedValue = newValue;
  }
}
